import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { InterfaceElement } from '../model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { CosyCommunicationControllerService, SearchOption } from '../service/controller/cosy-communication-controller.service';
import { UXControllerService } from '../service/controller/ux-controller.service';

@Component({
  selector: 'app-cosy-appmap',
  templateUrl: './cosy-appmap.component.html',
  styleUrls: ['./cosy-appmap.component.css']
})
export class CosyAppmapComponent implements OnInit {

  @Input() ie: InterfaceElement;
  @ViewChild('autocompleteInput') autocompleteInput: ElementRef;
  @ViewChild('appMapSearchTemplate', {static: false}) appSearchTemp: TemplateRef<void>;
  searchControl = new FormControl();
  public modalRef: BsModalRef;
  
  public placeholder : string = 'Path Search';
  public searchedTerm: string='';
  public isSearchProceed: boolean = false;
  appMapSearchList = [];
  
  constructor(
    public cosyCommunicationControllerService: CosyCommunicationControllerService,
    private uxControllerService: UXControllerService,
    private modalService: BsModalService) { 
      
    }

  ngOnInit(): void {
  }

  openSearch(){
    this.modalRef = this.modalService.show(this.appSearchTemp, { class: 'modal-lg modal-dialog-scrollable' });
  }

  loadPathLocation(sop:SearchOption){
    this.cosyCommunicationControllerService.setSessionKey(this.cosyCommunicationControllerService.localSessionID, "NextAppStateID", sop.ID)
    .subscribe(
      res=> {
        if (this.ie.Attributes.OnSelectUAID != null) {
         this.uxControllerService.fetchUserAction(this.ie.Attributes.OnSelectUAID, this.ie, null, sop.ID, null, null, null, null, null);
        }
      },
      error => console.error('ERROR: ', error)
    )
  }

 
  processSearchAction(searchText:string){
    this.isSearchProceed  = true;
    this.appMapSearchList = [];
    if (searchText == ''){
     
      let searchValue = this.searchControl.value;
      
      this.cosyCommunicationControllerService.searchOption.forEach(element => searchText += element.searchString);
      if(searchValue != '') searchText += searchValue; 
    }

    console.log('SearchText: ', searchText);
    if(searchText!=null && searchText!=''){

      this.cosyCommunicationControllerService.getAppMapPath(this.cosyCommunicationControllerService.localSessionID, searchText).subscribe(
        res => {
          if(res['appMapPath']!=''){
          console.log('Response: ', res['appMapPath']);
         
          let appMapSearchOptions = [];
          
          let so:SearchOption = new SearchOption();
          let oddSearchPaths: string[] =  res['appMapPath'].split('~|~');
          for(let osp of oddSearchPaths){
            
            appMapSearchOptions = []; 
            so = new SearchOption();
            let oddOptionList = [];
            let mainOption = osp.substring(0, osp.indexOf('~:~'));
            let oddOption  = osp.substring(osp.indexOf('~:~')+3, osp.length );
            oddOptionList.push(mainOption);
            
            if(oddOption!= '') {
              mainOption = mainOption.concat(':')
              oddOptionList =  oddOptionList.concat(oddOption.split('~->~'));

            }
            
            for(let ooa=0; ooa<oddOptionList.length; ooa++){
              let sop: SearchOption = new SearchOption();
                
              if(oddOptionList[ooa].indexOf('AppStateID')>-1){
                sop.displayName = oddOptionList[ooa].substring(0, oddOptionList[ooa].indexOf('['));
                if(ooa>0 && ooa < oddOptionList.length-1){
                  sop.displayName =  sop.displayName.concat('/');
                }
              
                sop.ID = oddOptionList[ooa].substring(oddOptionList[ooa].indexOf('AppStateID')+11,oddOptionList[ooa].indexOf('%%]'))
              
              } else {
                  sop.displayName = oddOptionList[ooa];
              }

              if(ooa==0 && oddOptionList.length >1){
                sop.displayName =  sop.displayName.concat(':');
              }  
              appMapSearchOptions.push(sop);
            }

            this.appMapSearchList.push(appMapSearchOptions);
          }
        }
        },
        error => console.error('ERROR: ', error),
      );
    }
  }
}
